'use client'
import { Clock, CheckCircle2, Sparkles } from 'lucide-react'
import { StarIcon } from './medallions/star-icon'

export interface WeekStatsStripProps {
  stats: { rounds: number; passed: number; perfect: number; starsEarned: number }
}

export function WeekStatsStrip({ stats }: WeekStatsStripProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
      <Stat label="This week" value={stats.rounds} sub="rounds" icon={<Clock className="h-3.5 w-3.5" />} />
      <Stat label="Passed" value={stats.passed} sub={`of ${stats.rounds}`} icon={<CheckCircle2 className="h-3.5 w-3.5" />} accent="text-emerald-500 dark:text-emerald-400" />
      <Stat label="Perfect" value={stats.perfect} sub="rounds" icon={<Sparkles className="h-3.5 w-3.5" />} accent="text-primary" />
      <Stat label="Stars earned" value={stats.starsEarned} sub="this week" icon={<StarIcon size={14} />} accent="text-amber-500 dark:text-amber-300" />
    </div>
  )
}

function Stat({ label, value, sub, icon, accent = 'text-foreground' }: {
  label: string; value: number; sub: string; icon: React.ReactNode; accent?: string
}) {
  return (
    <div className="rounded-xl border border-border bg-muted/40 px-3 py-2.5">
      <div className="flex items-center justify-between text-[10px] uppercase tracking-widest text-muted-foreground">
        <span>{label}</span>
        <span className={accent}>{icon}</span>
      </div>
      <div className="mt-0.5 flex items-baseline gap-1">
        <span className={`text-xl font-bold tabular-nums ${accent}`}>{value}</span>
        <span className="text-[11px] text-muted-foreground">{sub}</span>
      </div>
    </div>
  )
}
